export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0 w-full lg:w-1/2">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20modern%20workspace%20desk%20with%20laptop%20displaying%20neat%20spreadsheet%20interface%20with%20product%20rows%20and%20categories%2C%20warm%20natural%20daylight%20from%20window%2C%20color%20coded%20sticky%20notes%20on%20wall%20beside%20monitor%2C%20clean%20minimalist%20creative%20office%20aesthetic%2C%20productive%20calm%20atmosphere%2C%20warm%20beige%20and%20cream%20tones%2C%20sophisticated%20editorial%20photography&width=800&height=600&seq=whatis-section-v2-2026&orientation=landscape"
                alt="Pandabuy Spreadsheet organized fashion finds on a workspace"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-4">
              About
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-tight">
              What Is a Pandabuy Spreadsheet?
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              A <strong>Pandabuy Spreadsheet</strong> is an organized collection of shopping links, product references,
              and community finds that help users discover popular fashion items faster. Our spreadsheet categories
              cover thousands of verified products across <strong>shoes, hoodies, t-shirts, jackets, bags, accessories,
              and more</strong> — all curated by a community of experienced shoppers.
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              Instead of spending hours searching through forums and social media, our Pandabuy Spreadsheet directory
              lets you browse by category, compare options, and find trending products in seconds. Every link is
              verified and <strong>updated daily</strong> to ensure the best shopping experience.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['Shoes', 'Hoodies', 'T-Shirts', 'Bags', 'Accessories', 'Budget Finds'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 text-xs font-medium text-foreground-700 bg-background-50 border border-background-200/70 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}